/** User/agent message may embed markdown tables or fenced code.
 *  Must match GFM tables where the separator row uses spaces (e.g. `| --- |`)
 *  not only compact `|---` — otherwise IntentConfirmCard falls back to plain
 *  text and tables never render on first paint.
 */
export function messageHasTableOrFence(content: string): boolean {
  if (content.includes("```")) return true;
  return looksLikeMarkdownTable(content);
}

function looksLikeMarkdownTable(text: string): boolean {
  if (!text.includes("|")) return false;
  const lines = text
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);
  for (let i = 0; i < lines.length - 1; i += 1) {
    if (
      lines[i].startsWith("|") &&
      lines[i + 1].startsWith("|") &&
      lines[i + 1].includes("---")
    ) {
      return true;
    }
  }
  return false;
}
